<template>
  <TableBase
    :table="table"
    :caption="caption"
    :sortBy="sortBy"
    :sortDirection="direction"
    layout="fixed"
  >
    <template #header-cell="{ cell }">
      <TextBase v-if="!cell.isLoading" :text="cell.text" :type="textTypeHeader" weight="bold" />
      <PulseLoader v-else :loading="true" color="#3F46D6" size="8px" />
    </template>
    <template #body-cell="{ cell }">
      <TextBase v-if="!cell.isLoading" :text="cell.text" :type="textTypeCell" />
      <PulseLoader v-else :loading="true" color="#3F46D6" size="6px" />
    </template>
  </TableBase>
</template>

<script lang="ts" setup>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import TableBase from './TableBase.vue'
import TextBase, { TextType } from './TextBase.vue'
import { computed } from 'vue'

export type BasicTable = {
  headers?: { text: string; isLoading?: boolean; textAlign?: 'left' | 'center' | 'right' }[]
  rows: { text: string; isLoading?: boolean; textAlign?: 'left' | 'center' | 'right' }[][]
}

type Props = {
  caption: string
  textTypeHeader?: TextType
  textTypeCell?: TextType
  sortBy?: (i: number) => string | number
  direction?: 'asc' | 'desc'
  table: BasicTable
}

const props = withDefaults(defineProps<Props>(), {
  textTypeHeader: 'tiny',
  textTypeCell: 'tiny',
  direction: 'asc',
  sortBy: undefined
})

const table = computed(() => ({
  headers: {
    top: props.table.headers?.map((header) => ({
      text: header.text,
      isLoading: header.isLoading,
      style: {
        textAlign: header.textAlign ?? 'left'
      }
    }))
  },
  body: props.table.rows.map((row) =>
    row.map((cell) => ({
      text: cell.text,
      style: {
        textAlign: cell.textAlign ?? 'left'
      },
      isLoading: cell.isLoading
    }))
  )
}))
</script>
